import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const MuiSettingsRow = styled(Box)({
	width: '100%',
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
});
